import CityPageTemplate from "../city-template/CityPageTemplate";
import { stPaulConfig } from "./data";

export default function StPaulPage() {
  return <CityPageTemplate config={stPaulConfig} />;
}